import React, { useEffect, useState, useCallback } from 'react';
import { InputGroup, FormControl, Button } from 'react-bootstrap';
import { FiSearch, FiX } from 'react-icons/fi';

const CustomPagination = ({
  page,
  pages,
  perPage,
  onPageChange,
  onPerPageChange,
  perPageOptions = [10, 25, 50, 100],
  search = '',
  onSearchChange = null // Now explicitly null by default
}) => {
  const [pageInput, setPageInput] = useState(page);
  const [perPageInput, setPerPageInput] = useState(perPage);
  const [searchInput, setSearchInput] = useState(search);
  const [searchTimeout, setSearchTimeout] = useState(null);

  useEffect(() => {
    setPageInput(page);
  }, [page]);

  useEffect(() => {
    setPerPageInput(perPage);
  }, [perPage]);

  useEffect(() => {
    setSearchInput(search);
  }, [search]);

  const handlePageInputChange = (e) => {
    setPageInput(e.target.value);
  };

  const handlePerPageInputChange = (e) => {
    setPerPageInput(parseInt(e.target.value));
    onPerPageChange(parseInt(e.target.value));

  };

  


  const handlePageInputBlur = () => {
    let newPage = parseInt(pageInput);
    if (isNaN(newPage) || newPage < 1) newPage = 1;
    if (newPage > pages) newPage = pages;
    onPageChange(newPage);
    setPageInput(newPage);
  };

  const handlePageInputKeyDown = (e) => {
    if (e.key === 'Enter') {
      handlePageInputBlur();
    }
  };

  // Debounced search handler
  const handleSearchChange = useCallback((e) => {
    const value = e.target.value;
    setSearchInput(value);
    
    // Clear previous timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    
    // Set new timeout
    setSearchTimeout(
      setTimeout(() => {
        if (onSearchChange) {
          onSearchChange(value);
        }
      }, 500) // 500ms debounce delay
    );
  }, [onSearchChange, searchTimeout]);

  // Clear search handler
  const handleClearSearch = useCallback(() => {
    setSearchInput('');
    if (onSearchChange) {
      onSearchChange('');
    }
  }, [onSearchChange]);

  // Clean up timeout on unmount
  useEffect(() => {
    return () => {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
    };
  }, [searchTimeout]);

  return (
    <div className="datatable-pagination  justify-content-between align-items-center">
      {/* Conditionally render search box only if onSearchChange is provided */}
      
        <div  style={{ opacity: onSearchChange ? 1 : 0 }}>
          <InputGroup style={{ maxWidth: '400px', marginLeft: 'auto' }}>
            <InputGroup.Text>
              <FiSearch />
            </InputGroup.Text>
            <FormControl
              placeholder="Email..."
              value={searchInput}
              onChange={handleSearchChange}
              aria-label="Search"
            />
            <div className='d-flex ' style={{ paddingLeft: '10px'}}>
            {searchInput && (
              <Button
                variant="outline-secondary"
                onClick={handleClearSearch}
                aria-label="Clear search"
              >
                <FiX />
              </Button>
            )}
            </div>
          </InputGroup>
        </div>
      

      <div className="pagination-controls">
        <div className="per-page-selector ">
          <span className="me-2">Rows per page:</span>
          <select
            className="form-select form-select-sm"
            style={{ width: '80px' }}
            value={perPageInput}
            onChange={handlePerPageInputChange}
          >
            {perPageOptions.map(option => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        </div>

        <div className="page-navigation">
          <div className="page-buttons">
            <button
              className="nav-button"
              disabled={page === 1}
              onClick={() => onPageChange(1)}
              title="First Page"
            >
              «
            </button>
            <button
              className="nav-button"
              disabled={page === 1}
              onClick={() => onPageChange(page - 1)}
              title="Previous Page"
            >
              ‹
            </button>

            <div className="page-input mx-2 d-flex align-items-center">
              <input
                type="number"
                className="form-control form-control-sm"
                style={{ width: '60px' }}
                min="1"
                max={pages}
                value={pageInput}
                onChange={handlePageInputChange}
                onBlur={handlePageInputBlur}
                onKeyDown={handlePageInputKeyDown}
              />
              <span className="ms-2">of {pages}</span>
            </div>

            <button
              className="nav-button"
              disabled={page === pages}
              onClick={() => onPageChange(page + 1)}
              title="Next Page"
            >
              ›
            </button>
            <button
              className="nav-button"
              disabled={page === pages}
              onClick={() => onPageChange(pages)}
              title="Last Page"
            >
              »
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomPagination;